/*eslint-disable */

// import IdleWarningModal from '@/components/common/IdleWarningModal/index.vue';

import footer from '@/components/common/footer/index.vue';
import header from '@/components/common/header/index.vue';

// import { idleTimeoutMixin } from '@/mixins/idleTimeoutMixin';

export default {
  name: 'app',
  // mixins: [idleTimeoutMixin],
  components: {
    'app-header':header,
    'app-footer':footer,
    // IdleWarningModal
  },
  props: [],
}
